import { render, staticRenderFns } from "./ClientWithoutCallingSales.vue?vue&type=template&id=30a8ff2a&"
import script from "./ClientWithoutCallingSales.vue?vue&type=script&lang=js&"
export * from "./ClientWithoutCallingSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports